<template>
  <hs-dialog v-model="show" height="100%" ref="detailsDialog" renderType="if">
    <div class="hs-container-page" @click.stop>
      <div class="hs-container-child hs-container-child-box" @click.stop>
        <c-dialog-header
            style="background-color: #fff"
            :title="$t('Choose_x', 'function', [powerDetails.title])"
            @close="close"
        />

        <hs-search-bar-new
            className="style2"
            v-model="KeyWord"
            :placeholder="$t('PleaseEnterTheTraveler')"
            :hasClear="!!KeyWord"
            @clear="KeyWord = ''"
        />

        <hs-scroll
          class="table-view"
          ref="tableView"
          :data="datalist"
          :options="tableViewOptions"
          @pulling-down="_getDatalist"
          @pulling-up="_getDatalistMore"
        >
          <ul>
            <div style="width: 100%; height: 12px"></div>
            <div class="main-content">
              <template v-if="!KeyWord">
                <div v-if="hasAddBtn || hasImportBtn" style="padding-bottom: 12px;">
                  <div style="width: 100%;height: 12px"></div>
                  <hs-cell-1 :showLogo="false" style="padding: 0 12px">
                    <div class="custom-cell">
                      <hs-button
                          v-if="hasAddBtn"
                          class="button btn-add"
                          fontSize="15px"
                          width="100%"
                          height="40px"
                          @click="_addPassenger(Number(XOrder.TravelType) === 1 ? 2 : 0)"
                      >{{ $t("New") }}</hs-button
                      >
                      <hs-button
                          v-if="hasImportBtn"
                          class="button btn-import"
                          fontSize="15px"
                          type="common"
                          width="100%"
                          height="40px"
                          @click="$refs.Person && $refs.Person.open()"
                      >{{ $t("Import") }}</hs-button
                      >
                    </div>
                  </hs-cell-1>
                </div>
              </template>
              <c-passenger-list-item
                  v-for="(item, index) in datalist"
                  :key="index"
                  :OrderBusinessType="OrderBusinessType"
                  :item="{...item}"
                  :TravelType="XOrder.TravelType"
                  :title="'请补全常旅客的基本信息'"
                  :showCredential="true"
                  @gotoDetails="_gotoDetails(index, item)"
              />
            </div>
            <hs-null
                v-if="!datalist || datalist.length === 0"
                style="padding-top: calc(40dvh - 146px)"
                styleType="empty"
                :title="$t('NoDataContent')"
                :isGrayBg="true"
                :sub-title="KeyWord && $t('SorryCouldNotFindIt_x', 'function', [KeyWord])"
            />

            <hs-null
                v-if="!datalist || datalist.length === 0"
                style="padding-top: calc(32dvh - 150px)"
                styleType="empty"
                :isGrayBg="true"
                :title="$t('NoDataContent')"
            />
            <div style="width: 100%; height: 10px"></div>
          </ul>
        </hs-scroll>

        <footer>
          <hs-button
            width="100%"
            height="36px"
            type="full-square"
            @click="_confirm"
            >{{ $t("Confirm") }}</hs-button
          >
        </footer>
      </div>
      <!-- 常旅客详情 -->
      <passenger-details
        ref="PassengerDetails"
        :XOrder="XOrder"
        :details="passengerDetails"
        :OrderBusinessType="OrderBusinessType"
        :BookingLimit="BookingLimit"
        :isClose="true"
        :ExpirationTime="ExpirationTime"
        @delegate="_delegateWithPassengerDetails"
      ></passenger-details>

      <!-- 导入列表 -->
      <person ref="Person"></person>

      <!--儿童婴儿提示弹框-->
      <c-small-fourteen-alert
        ref="CSmallFourteenAlert"
        :details="CSmallFourteenAlertData"
        :confirmFn="_CSmallFourteenAlertFun"
      />
    </div>
  </hs-dialog>
</template>
<script type="text/ecmascript-6">
import HsButton from 'base/hs-button/hs-button'
import HsCell1 from 'base/hs-tableview/hs-cell-1/hs-cell-1'
import HsNull from 'base/hs-null/hs-null'
import HsScroll from 'base/hs-scroll/hs-scroll'
import HsSection from 'base/hs-tableview/hs-section/hs-section'
import PassengerDetails from 'pages/personal/passengers/details.vue'
import Person from 'pages/personal/passengers/person.vue'
import CSmallFourteenAlert from 'components/c-passenger/c-small-fourteen-alert'
import HsClose from 'base/hs-close/hs-close'
import {kpiFrequentTravelerList, kpiFrequentTravelerPut, kpiFrequentTravelerAdd} from 'api'
import mixinDes from 'common/mixin/passenger/mixin-des'
import NewPassenger from 'common/model/passenger/newPassenger'
import MixinPassengerExtendFieldPower from 'common/mixin/passenger/mixin-passenger-extend-field-power'
import {getIsBabySmallFourteen, getIsAdultSmallEighteen, getPassengerType} from '../../common/utility/utils';
import HsDialog from 'base/hs-dialog/hs-dialog'
import HsSearchBarNew from "@/base/hs-search-bar/hs-search-bar-new.vue";
import CDialogHeader from "@/components/c-header/c-dialog-header.vue";
import CPassengerListItem from "@/components/c-passenger/c-passenger-list-item.vue";
export default {
  props: {
    XOrder: {
      type: Object,
      default: function() {
        return {}
      }
    },
    OrderBusinessType: {
      type: Number,
      default: 1
    },
    MaxLength: {
      type: Number,
      default: 9999
    },
    BookingLimit: {
      type: Object,
      default: () => {
        return null
      }
    },
    GuestToRoomNo: {
      default: undefined
    },
    ExpirationTime: {
      type: String,
      default: null
    },
    isNotShowNickName: { // 是否不展示昵称 针对国际机票需求单 后端暂不支持昵称
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      CSmallFourteenAlertData: {
        PassengerType: 1,
        IsCarryChild: false,
        IsCarryInfant: false
      },
      tableViewOptions: {
        pullDownRefresh: {
          threshold: 50
        },
        pullUpLoad: false
      },
      details: {},
      datalist: [],
      currentPageIndex: 1,
      currentPageSize: 20,
      KeyWord: '',
      show: false,
      /** 当前选中的乘客 */
      currentSelectedPassengers: [],
      /** 常旅客详情 */
      passengerDetails: {},
      /** 各板块权限 */
      powerDetails: {
        title: '', // 标题
        maxLength: 9999, // 最多可选人数
        requiredCredential: false, // 证件号必填
        requiredEffectiveDate: false, // 证件有效期必填
        requiredNation: false, // 国籍必填
        requiredMobile: true // 手机号必填
      }
    }
  },
  mixins: [mixinDes, MixinPassengerExtendFieldPower],
  watch: {
    show(val) {
      if (val) {
        this.KeyWord = ''
        // 初始化已选乘客
        let Passengers = []
        if (this.OrderBusinessType === 0) { // 用餐
          Passengers = JSON.parse(JSON.stringify(this.XOrder.Passengers))
        } else if (
          this.OrderBusinessType === 1 ||
          this.OrderBusinessType === 6 ||
          this.OrderBusinessType === 10 ||
          this.OrderBusinessType === 14 ||
          this.OrderBusinessType === 17 || // 出差申请单
          this.OrderBusinessType === 10006 || // 出差申请单
          this.OrderBusinessType === 18 // 汽车票
        ) {
          Passengers = JSON.parse(JSON.stringify(this.XOrder.Passengers))
        } else if (this.OrderBusinessType === 15) { // 用餐
          Passengers = JSON.parse(JSON.stringify(this.XOrder.Diningers))
        } else {
          Passengers = JSON.parse(JSON.stringify(this.XOrder.Guests))
        }
        this.currentSelectedPassengers = Passengers.map(v => {
          return this._checkList(v)
        })
        this._initPowerDetails()

        this._getDatalist()
      }
    }
  },
  computed: {
    childrenCanBook() {
      let value = true
      this.XOrder.SelectedFlights && this.XOrder.SelectedFlights.map(m => {
        if (
          !m.ChildChargeInfo ||
          (m.ChildChargeInfo && m.ChildChargeInfo.SalePrice <= 0)
        ) {
          value = false
        }
      })
      return value
    },
    babyCanBook() {
      let value = true
      this.XOrder.SelectedFlights && this.XOrder.SelectedFlights.map(m => {
        if (!m.InfantChargeInfo || (m.InfantChargeInfo && m.InfantChargeInfo.SalePrice <= 0)) {
          value = false
        }
      })
      return value
    },
    isShowNickName() { // 是否展示昵称
      let isShowNickName = this.getSetting('常用配置:昵称:展示') || (Number(this.XOrder.TravelType) === 1)
      // 国际机票需求单 暂时不展示昵称 后端暂不支持
      if (this.isNotShowNickName) {
        isShowNickName = false
      }
      return isShowNickName
    },
    hasAddBtn() {
      let TravelType = Number(this.XOrder.TravelType)
      let val = false
      if (TravelType === 0 && (this.hasPower('我的:常旅客管理:因公添加') || this.hasPower('我的:常旅客管理:因公非员工添加'))) {
        val = true
      }
      if (TravelType === 1 && this.hasPower('我的:常旅客管理:因私添加')) {
        val = true
      }
      return val
    },
    hasImportBtn() {
      let TravelType = Number(this.XOrder.TravelType)
      return TravelType === 0 && this.hasPower('我的:常旅客管理:因公导入')
    },
    hsScrollHeight() {
      let header = 48
      let tabHeight = this.tabOptions && this.tabOptions.length > 1 ? 40 : 0
      let searchBar = 56
      return `calc(100% - ${header}px - ${tabHeight}px - ${searchBar}px)`
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close(type) {
      if (type === 'reset') {
        this.show = false
      } else {
        if (this._checkAlertIsOpen('PassengerDetails')) {
          return true
        } else {
          this.show = false
        }
      }
    },

    /** 根据板块初始化页面权限 */
    _initPowerDetails() {
      // 常旅客
      if (this.OrderBusinessType === 0) {
        // 常旅客不用此列表
        // this.powerDetails.requiredMobile = false
        this.powerDetails.title = this.$t('Traveler')
        this.powerDetails.maxLength = 9
        this.powerDetails.showEffectiveDate = true
        this.powerDetails.showDefaultNameType = false
        this.powerDetails.showNation = true
        this.powerDetails.showBirthday = true
        this.powerDetails.showGender = true
        this.powerDetails.showCard = true
      // 国内机票
      } else if (this.OrderBusinessType === 1) {
        this.powerDetails.title = this.$t('PassengerFlight')
        this.powerDetails.maxLength = 9
        this.powerDetails.requiredCredential = true
        this.powerDetails.requiredGender = true
        this.powerDetails.requiredBirthday = true
      // 国际机票
      } else if (this.OrderBusinessType === 6) {
        this.powerDetails.title = this.$t('PassengerFlight')
        this.powerDetails.maxLength = 9
        this.powerDetails.requiredCredential = true
        this.powerDetails.requiredEffectiveDate = true
        this.powerDetails.requiredNation = true
        this.powerDetails.requiredBirthday = true
        this.powerDetails.requiredGender = true
      // 国内酒店
      } else if (this.OrderBusinessType === 2) {
        this.powerDetails.title = this.$t('Roomer')
        this.powerDetails.maxLength = this.MaxLength
        this.powerDetails.requiredCredential = (this.XOrder.RatePlan && this.XOrder.RatePlan.IdentityRule === 1)
      // 国际酒店
      } else if (this.OrderBusinessType === 11) {
        this.powerDetails.title = this.$t('Roomer')
        this.powerDetails.maxLength = this.MaxLength
      // 火车票
      } else if (this.OrderBusinessType === 10) {
        this.powerDetails.title = this.$t('PassengerVehicle')
        this.powerDetails.maxLength = 9
        this.powerDetails.requiredCredential = true
        this.powerDetails.requiredEffectiveDate = true
        this.powerDetails.requiredBirthday = true
      // 用车
      } else if (this.OrderBusinessType === 14) {
        this.powerDetails.title = this.$t('PassengerVehicle')
        this.powerDetails.maxLength = this.MaxLength
      } else if (this.OrderBusinessType === 15) {
        this.powerDetails.title = this.$t('Diner')
        this.powerDetails.maxLength = this.MaxLength
      } else if (this.OrderBusinessType === 17) { // 出差申请单
        this.powerDetails.title = this.$t('Traveler')
        this.powerDetails.requiredMobile = true
        this.powerDetails.maxLength = this.MaxLength
      } else if (this.OrderBusinessType === 18) { // 汽车票
        this.powerDetails.title = this.$t('PassengerVehicle')
        this.powerDetails.requiredMobile = true
        this.powerDetails.requiredCredential = true
        this.powerDetails.maxLength = this.MaxLength
      } else if (this.OrderBusinessType === 10006) { // 国际机票询价单
        this.powerDetails.title = this.$t('PassengerFlight')
        this.powerDetails.maxLength = 9
        this.powerDetails.requiredCredential = true
        this.powerDetails.requiredEffectiveDate = true
        this.powerDetails.requiredNation = true
        this.powerDetails.requiredBirthday = true
        this.powerDetails.requiredGender = true
      }
    },

    _getParams() {
      let OrderBusinessType = this.OrderBusinessType
      // 询价单获取常旅客按国籍机票的类型请求
      if (this.OrderBusinessType === 10006) {
        OrderBusinessType = 6
      }
      return {
        KeyWord: this.KeyWord,
        OrderBusinessType: OrderBusinessType,
        TravelType: this.XOrder.TravelType
      }
    },

    /** 获取常旅客列表 */
    _getDatalist() {
      this.details = {}
      this.datalist = []
      this.currentPageIndex = 1
      this.tableViewOptions.pullUpLoad = false
      let params = {
        ...this._getParams(),
        PageIndex: this.currentPageIndex,
        PageSize: this.currentPageSize
      }
      kpiFrequentTravelerList(params).then((res) => {
        console.log('获取常旅客列表: ', res)
        this.details = res.ResultData
        let list = res.ResultData.FrequentTravelers.map(v => {
          return this._checkList(new NewPassenger(v))
        })
        list = list.filter(element => this.currentSelectedPassengers.map(v => v.ID).indexOf(element.ID) < 0)
        this.datalist = this.currentSelectedPassengers.concat(list)
        if (res.ResultData.FrequentTravelers.length >= this.currentPageSize) {
          this.tableViewOptions.pullUpLoad = {threshold: 50}
        }
        this.$refs.tableView && this.$refs.tableView.forceUpdate();
      })
    },

    /** 获取更多常旅客列表 */
    _getDatalistMore() {
      let params = {
        ...this._getParams(),
        PageIndex: this.currentPageIndex + 1,
        PageSize: this.currentPageSize
      }
      kpiFrequentTravelerList(params).then((res) => {
        console.log('常旅客列表： ', res)
        this.currentPageIndex++
        let list = res.ResultData.FrequentTravelers.map(v => {
          return this._checkList(new NewPassenger(v))
        })
        list = list.filter(element => this.currentSelectedPassengers.map(v => v.ID).indexOf(element.ID) < 0)
        this.datalist = this.datalist.concat(list)
        if (res.ResultData.FrequentTravelers.length < this.currentPageSize) {
          this.tableViewOptions.pullUpLoad = false
        } else {
          this.tableViewOptions.pullUpLoad = {threshold: 50}
        }
        this.$refs.tableView && this.$refs.tableView.forceUpdate();
      })
    },

    /** 检查和补充数据完整性 */
    _checkList(v) {
      let res = JSON.parse(JSON.stringify(v))
      let BookingLimit = this.BookingLimit // 特殊的姓名限制
      // 0 不限 1 中文 2 英文
      if (BookingLimit && BookingLimit.PassgerNameType) {
        res.DefaultNameType = BookingLimit.PassgerNameType === 1 ? 0 : res.DefaultNameType
        res.DefaultNameType = BookingLimit.PassgerNameType === 2 ? 1 : res.DefaultNameType
      }

      // 1. 赋值通知初始化参数
      if (this.OrderBusinessType === 1) {
        // 国内机票正常下单 因公因私 短信邮件都读配置
        res.IsSendBookSms = this.noValue(res.IsSendBookSms) ? this.getSetting('国内机票配置:正常订单:乘客预订信息:短信') : res.IsSendBookSms
        res.IsSendBookEmail = this.noValue(res.IsSendBookEmail) ? this.getSetting('国内机票配置:正常订单:乘客预订信息:邮箱') : res.IsSendBookEmail
        res.IsSendIssuedSms = this.noValue(res.IsSendIssuedSms) ? this.getSetting('国内机票配置:正常订单:乘客出票信息:短信') : res.IsSendIssuedSms
        res.IsSendIssuedEmail = this.noValue(res.IsSendIssuedEmail) ? this.getSetting('国内机票配置:正常订单:乘客出票信息:邮箱') : res.IsSendIssuedEmail
      } else if (this.OrderBusinessType === 6) {
        res.IsSendIssuedSms = this.noValue(res.IsSendIssuedSms) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('国际机票配置:正常订单:乘客出票信息:短信') : false) : res.IsSendIssuedSms
        res.IsSendIssuedEmail = this.noValue(res.IsSendIssuedEmail) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('国际机票配置:正常订单:乘客出票信息:邮箱') : false) : res.IsSendIssuedEmail
      } else if (this.OrderBusinessType === 2) {
        res.IsSendConfirmSms = this.noValue(res.IsSendConfirmSms) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('国内酒店配置:入住人确认信息:短信') : false) : res.IsSendConfirmSms
        res.IsSendConfirmEmail = this.noValue(res.IsSendConfirmEmail) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('国内酒店配置:入住人确认信息:邮箱') : false) : res.IsSendConfirmEmail
      } else if (this.OrderBusinessType === 11) {
        res.IsSendConfirmSms = this.noValue(res.IsSendConfirmSms) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('国际酒店配置:入住人确认信息:短信') : false) : res.IsSendConfirmSms
        res.IsSendConfirmEmail = this.noValue(res.IsSendConfirmEmail) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('国际酒店配置:入住人确认信息:邮箱') : false) : res.IsSendConfirmEmail
      } else if (this.OrderBusinessType === 10) {
        res.IsSendIssuedSms = this.noValue(res.IsSendIssuedSms) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('火车票配置:正常订单:乘客出票信息:短信') : false) : res.IsSendIssuedSms
        res.IsSendIssuedEmail = this.noValue(res.IsSendIssuedEmail) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('火车票配置:正常订单:乘客出票信息:邮箱') : false) : res.IsSendIssuedEmail
      } else if (this.OrderBusinessType === 14) {
        res.IsSendConfirmSms = this.noValue(res.IsSendConfirmSms) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('用车配置:乘客确认消息:短信') : false) : res.IsSendConfirmSms
        res.IsSendConfirmEmail = this.noValue(res.IsSendConfirmEmail) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('用车配置:乘客确认消息:邮箱') : false) : res.IsSendConfirmEmail
      } else if (this.OrderBusinessType === 15) {
        res.IsSendConfirmSms = this.noValue(res.IsSendConfirmSms) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('用餐配置:乘客确认消息:邮箱') : false) : res.IsSendConfirmSms
        res.IsSendConfirmEmail = this.noValue(res.IsSendConfirmEmail) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('用餐配置:乘客确认消息:邮箱') : false) : res.IsSendConfirmEmail
      } else if (this.OrderBusinessType === 18) { // 汽车票
        res.IsSendBookSms = this.noValue(res.IsSendBookSms) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('汽车票配置:乘客预订消息:短信') : false) : res.IsSendBookSms
        res.IsSendBookEmail = this.noValue(res.IsSendBookEmail) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('汽车票配置:乘客预订消息:邮箱') : false) : res.IsSendBookEmail
        res.IsSendIssuedSms = this.noValue(res.IsSendIssuedSms) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('汽车票配置:乘客出票消息:短信') : false) : res.IsSendIssuedSms
        res.IsSendIssuedEmail = this.noValue(res.IsSendIssuedEmail) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('汽车票配置:乘客出票消息:邮箱') : false) : res.IsSendIssuedEmail
      } else if (this.OrderBusinessType === 10006) { // 询价单
        // res.IsSendConfirmSms = this.noValue(res.IsSendConfirmSms) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('国际机票配置:正常订单:乘客出票信息:短信') : false) : res.IsSendConfirmSms
        // res.IsSendConfirmEmail = this.noValue(res.IsSendConfirmEmail) ? (Number(this.XOrder.TravelType) === 0 ? this.getSetting('国际机票配置:正常订单:乘客出票信息:邮箱') : false) : res.IsSendConfirmEmail
        res.IsSendConfirmSms = false
        res.IsSendConfirmEmail = false
      }

      // 冗余
      res.UpID = res.UpID ? res.UpID : res.ID

      res.Incomplete = false
      res.IsExpirationTime = false

      let credential = null
      if (this.powerDetails.requiredCredential) {
        credential = res.Credentials.filter(a => a.CredentialType === res.DefaultCredentialType)[0]
        res.Credential = res.Credentials.filter(a => a.CredentialType === res.DefaultCredentialType)[0]

        /** 证件有效期 1900-01-01 则默认未填写 */
        credential && credential.EffectiveDate === '1900-01-01' && (credential.EffectiveDate = '')
        res.Credential && res.Credential.EffectiveDate === '1900-01-01' && (res.Credential.EffectiveDate = '')
      }

      // 根据证件类型里对应的字段更新是否现在是是否必填 证件签署国 // -1不限 0中文 1英文
      let NameType = credential ? Number(credential.NameType) : -1
      if (NameType === 0) {
        res.DefaultNameType = 0
      } else if (NameType === 1) {
        res.DefaultNameType = 1
      }
      let CredentialNation = credential ? Number(credential.CredentialNation) : 0 // 证件签署国 0 不显示 1 显示 2必填
      let PsgNation = credential ? Number(credential.PsgNation) : 0 // 国籍 0 不显示 1 显示 2必填
      let ExpireDateSetting = credential ? Number(credential.ExpireDateSetting) : 0 // 证件有效期 0 不显示 1 显示 2必填

      // 1. 中英文姓名必填一个
      if (
        this.OrderBusinessType === 0 &&
        this.noValue(res.ChName) &&
        (this.noValue(res.FirstName) || this.noValue(res.LastName))
      ) {
        res.Incomplete = true
      } else if (this.OrderBusinessType !== 0 && res.DefaultNameType === 0 && this.noValue(res.ChName)) {
        res.Incomplete = true
      } else if (this.OrderBusinessType !== 0 && res.DefaultNameType === 1 && (this.noValue(res.FirstName) || this.noValue(res.LastName))) {
        res.Incomplete = true

      // 2. 英文姓英文名需同时填写
      } else if ((this.OrderBusinessType !== 0 && res.DefaultNameType === 1) && res.LastName && this.noValue(res.FirstName)) {
        res.Incomplete = true
      } else if ((this.OrderBusinessType !== 0 && res.DefaultNameType === 1) && res.FirstName && this.noValue(res.LastName)) {
        res.Incomplete = true

      // 3. 保存的证件号必填
      } else if (this.powerDetails.requiredCredential && this.noValue(credential.CredentialNo)) {
        res.Incomplete = true

      // 4. 校验保存的证件号格式
      } else if (this.powerDetails.requiredCredential && !this.noValue(credential.CredentialNo) && credential.CredentialType === 1 && !this.idCard(credential.CredentialNo).valid) {
        res.Incomplete = true
      // eslint-disable-next-line
      } else if (this.powerDetails.requiredCredential && !this.noValue(credential.CredentialNo) && credential.CredentialNo.match(/[^a-zA-Z-0-9-\/\ ]/g) !== null) {
        res.Incomplete = true

      // 5. 国际机票证件有效期必填
      } else if (ExpireDateSetting === 2 && credential && this.noValue(credential.EffectiveDate)) {
        res.Incomplete = true

      // 证件有效期是否过期 证件有效期必填 且过期日期存在才校验
      } else if (ExpireDateSetting === 2 && credential && credential.EffectiveDate && this.ExpirationTime && credential.EffectiveDate < this.ExpirationTime) {
        res.Incomplete = true
        res.IsExpirationTime = true

      // 国内机票证件签署国
      } else if (CredentialNation === 2 && credential && (!credential.Nation || !credential.Nation.ID)) {
        res.Incomplete = true

      // 6. 国际机票国籍必填 其他业务读取后端字段必填则校验国籍
      } else if (PsgNation === 2 && credential && (!res.Nation || !res.Nation.Name)) {
        res.Incomplete = true

      // 7. 生日必填
      } else if (this.powerDetails.requiredBirthday && credential.CredentialType !== 1 && this.noValue(res.Birthday)) {
        res.Incomplete = true

      // 8. 国际机票时性别必选 男 或 女 否则不能选择
      } else if (this.powerDetails.requiredGender && Number(res.NewGender) !== 1 && Number(res.NewGender) !== 2) {
        res.Incomplete = true

      // 8. 业务板块手机号必填
      } else if (this.powerDetails.requiredMobile && this.noValue(res.Mobile)) {
        res.Incomplete = true

      // 9. 校验手机号格式
      } else if (!this.noValue(res.Mobile) && !this.isPhoneNumber(res.Mobile, res.MobileCountryCode)) {
        res.Incomplete = true

      // 10. 邮箱必填
      } else if (this.noValue(res.Email) && (res.IsSendBookEmail || res.IsSendIssuedEmail || res.IsSendConfirmEmail)) {
        res.Incomplete = true

      // 11. 校验邮箱格式
      } else if (!this.noValue(res.Email) && !this.isEmail(res.Email)) {
        res.Incomplete = true

      // 12. 成本中心 出差申请单、询价单不展示不校验
      } else if (
        this.OrderBusinessType !== 17 &&
        Number(this.XOrder.TravelType) === 0 &&
        Number(res.UpType) === 1 &&
        this.getSetting('常用配置:员工编号') &&
        this.getSetting('常用配置:员工编号:必填') &&
        !res.EmployeeNo
      ) {
        res.Incomplete = true
        // 12. 成本中心 出差申请单不展示不校验
      } else if (this.OrderBusinessType !== 17 && Number(this.XOrder.TravelType) === 0 && this.getSetting('常用配置:成本中心:必填') && (!res.CostCenter || !res.CostCenter.Name)) {
        res.Incomplete = true

      // 13. 检查部门 出差申请单不展示不校验
      } else if (this.OrderBusinessType !== 17 && Number(this.XOrder.TravelType) === 0 && this.getSetting('常用配置:部门:必填') && res.UpType === 1 && (!res.Department || !res.Department.Name)) {
        res.Incomplete = true

      // 14. 检查BU 出差申请单不展示不校验
      } else if (this.OrderBusinessType !== 17 && Number(this.XOrder.TravelType) === 0 && this.getSetting('常用配置:BU:必填') && res.UpType === 1 && (!res.BusinessUnit || !res.BusinessUnit.Name)) {
        res.Incomplete = true
        // 扩展字段 出差申请单不展示不校验
      } else if (this.OrderBusinessType !== 17 && Number(this.XOrder.TravelType) === 0 && res.UpType === 1 && this.mixinCheckExtendField(res, false)) {
        // 校验员工扩展字段
        res.Incomplete = true
      }

      // 国内机票  判断乘客类型 成人 儿童 婴儿
      if (this.OrderBusinessType === 1) {
        let {SelectedFlights} = this.XOrder
        let len = SelectedFlights.length
        let FlightDetails = SelectedFlights[len - 1] ? SelectedFlights[len - 1].FlightDetails : {}
        let lastSegmentTakeOffTime = FlightDetails.DepartDateTime ? this.beTime(FlightDetails.DepartDateTime, 'yyyy-MM-dd') : '' // 最后一程起飞时间
        res.PassengerType = getPassengerType(res.Birthday, lastSegmentTakeOffTime)
        res.isSmallFourteen = getIsBabySmallFourteen(res.Birthday, lastSegmentTakeOffTime)
        res.isAdultSmallEighteen = getIsAdultSmallEighteen(res.Birthday, lastSegmentTakeOffTime) // 小于18岁的成人
      }

      // console.log('res: ', res)
      return res
    },

    /** 添加常旅客 */
    _addPassenger() {
      this.passengerDetails = {}
      this.$set(this.passengerDetails, 'ChName', '')
      this.$set(this.passengerDetails, 'FirstName', '')
      this.$set(this.passengerDetails, 'LastName', '')
      this.$set(this.passengerDetails, 'NickName', '')
      this.$set(this.passengerDetails, 'NewGender', 0)
      this.$set(this.passengerDetails, 'Birthday', '')
      this.$set(this.passengerDetails, 'Email', '')
      this.$set(this.passengerDetails, 'Mobile', '')
      this.$set(this.passengerDetails, 'MobileCountryCode', '+86') // 手机国家代码
      this.$set(this.passengerDetails, 'Department', null)
      this.$set(this.passengerDetails, 'CostCenter', null)
      this.$set(this.passengerDetails, 'BusinessUnit', null)
      this.$set(this.passengerDetails, 'Credentials', this.details.SupportCredentialTypes.map(v => {
        return {
          CredentialName: v.CredentialName,
          CredentialType: v.CredentialType,
          CredentialNo: '',
          EffectiveDate: '',
          CredentialNation: v.CredentialNation, // 0 不显示 1 显示 2必填
          PsgNation: v.PsgNation, // 0 不显示 1 显示 2必填
          ExpireDateSetting: v.ExpireDateSetting, // 0 不显示 1 显示 2必填
          NameType: v.NameType, // -1不限 0中文 1英文
          Nation: null
        }
      }))
      let UpType = 1
      if (Number(this.XOrder.TravelType) === 0) { // 因公
        // 有员工的添加权限则默认员工 没有则读非员工权限 有则默认非员工
        if (this.hasPower('我的:常旅客管理:因公添加')) {
          UpType = 1
        } else if (this.hasPower('我的:常旅客管理:因公非员工添加')) {
          UpType = 2
        }
      } else {
        UpType = 2
      }
      this.$set(this.passengerDetails, 'UpType', UpType)
      this.$set(this.passengerDetails, 'Nation', null)
      this.$set(this.passengerDetails, 'TravelType', Number(this.XOrder.TravelType))
      this.$set(this.passengerDetails, 'TravelCardList', [])
      // 国际机票询价单默认按国际机票处理
      if (this.OrderBusinessType === 11 || this.OrderBusinessType === 6 || this.OrderBusinessType === 10006) {
        this.$set(this.passengerDetails, 'DefaultNameType', 1)
        this.$set(this.passengerDetails, 'DefaultCredentialType', 2)
      } else {
        this.$set(this.passengerDetails, 'DefaultNameType', 0)
        this.$set(this.passengerDetails, 'DefaultCredentialType', 1)
      }
      this.passengerDetails = this._checkList(this.passengerDetails)
      if (this.$refs.PassengerDetails) {
        this.$refs.PassengerDetails.open()
      }
    },

    /** 修改常旅客去详情页面 */
    _gotoDetails(index, item) {
      this.passengerDetails = item
      this.$set(this.passengerDetails, 'index', index)
      if (this.$refs.PassengerDetails) {
        this.$refs.PassengerDetails.open()
      }
    },

    /** 常旅客详情回调 */
    _delegateWithPassengerDetails(item) {
      let params = item
      params.OrderBusinessType = this.OrderBusinessType
      if (this.OrderBusinessType === 10006) { // 询价单获取常旅客按国籍机票的类型请求 10006 => 6
        params.OrderBusinessType = 6
      }
      // 编辑常旅客详情
      if (item.index >= 0) {
        kpiFrequentTravelerPut(params).then((res) => {
          console.log('修改: ', res)
          if (res.ResultData === true) {
            this.$toast(this.$t('SaveSucceed'))
            // 替换列表
            item = this._checkList(item)
            this.datalist.splice(item.index, 1, this._checkList(item))
            // 替换已选乘客信息
            let indexPassengers = this.currentSelectedPassengers.map(v => v.ID).indexOf(item.ID)
            if (indexPassengers >= 0) {
              this.currentSelectedPassengers.splice(indexPassengers, 1, item)
            } else if (this.OrderBusinessType === 11 && this.currentSelectedPassengers.filter(v => v.GuestToRoomNo === this.GuestToRoomNo).length < this.powerDetails.maxLength) {
              this.currentSelectedPassengers.push(Object.assign(item, {GuestToRoomNo: this.GuestToRoomNo}))
            } else if (this.OrderBusinessType !== 11 && this.currentSelectedPassengers.length < this.powerDetails.maxLength) {
              this.currentSelectedPassengers.push(item)
            }
            console.log('this.currentSelectedPassengers.filter(v => v.GuestToRoomNo).length: ', this.currentSelectedPassengers.filter(v => v.GuestToRoomNo).length)
            console.log('this.powerDetails.maxLength: ', this.powerDetails.maxLength)
            this.$refs.PassengerDetails && this.$refs.PassengerDetails.close('reset')
          } else {
            this.$toast(this.$t('SaveFailed'))
          }
        })
      } else {
        kpiFrequentTravelerAdd(params).then((res) => {
          console.log('常旅客添加: ', res)
          item.ID = res.ResultData.ID
          item.UpID = res.ResultData.ID
          item.TravelerID = res.ResultData.TravelerID
          item.IsRequiredAuthorizationCode = res.ResultData.IsRequiredAuthorizationCode
          this.$toast(this.$t('AddSucceed'))
          this.$refs.PassengerDetails && this.$refs.PassengerDetails.close('reset')
          if (this.OrderBusinessType === 11) {
            // 插入
            if (this.currentSelectedPassengers.filter(v => v.GuestToRoomNo === this.GuestToRoomNo).length < this.powerDetails.maxLength) {
              // this.currentSelectedPassengers.push(Object.assign(item, {GuestToRoomNo: this.GuestToRoomNo}))
              item.GuestToRoomNo = this.GuestToRoomNo
              this.datalist.splice(0, 0, this._checkList(item))
              this.currentSelectedPassengers.splice(0, 0, this._checkList(item))
            } else {
              this.datalist.splice(0, 0, this._checkList(item))
              // this.currentSelectedPassengers.splice(0, 0, this._checkList(item))
            }
          } else {
            // 插入
            item = this._checkList(item)
            this.datalist.splice(0, 0, this._checkList(item))
            if (this.OrderBusinessType === 11 && this.currentSelectedPassengers.filter(v => v.GuestToRoomNo === this.GuestToRoomNo).length < this.powerDetails.maxLength) {
              this.currentSelectedPassengers.splice(0, 0, Object.assign(item, {GuestToRoomNo: this.GuestToRoomNo}))
            } else if (this.OrderBusinessType !== 11 && this.currentSelectedPassengers.length < this.powerDetails.maxLength) {
              this.currentSelectedPassengers.splice(0, 0, item)
            }
            // this.currentSelectedPassengers.splice(0, 0, this._checkList(item))
          }
          // this._getDatalist()
        })
      }
    },

    // 提示框
    _CSmallFourteenAlertFun(hasChildren, hasBaby) {
      this.$emit('reQuery', hasChildren, hasBaby)
    },

    // 设置默认 是否带儿童 是否带婴儿
    _initCSmallFourteenAlertData(IsCarryChild, IsCarryInfant, PassengerType) {
      this.CSmallFourteenAlertData = {
        PassengerType,
        IsCarryChild,
        IsCarryInfant
      }
    },

    // 校验成人儿童婴儿
    _checkChildrenAndBaby(item) {
      // true 校验通过 false 校验不通过
      // if (this.XOrder.IsOA) {
      //   return true
      // }
      // 儿童婴儿仅针对国内机票校验
      if (this.OrderBusinessType !== 1) {
        return true
      }

      let IsDisplayFlightChildAndInfantPrice = this.getSetting('国内机票配置:正常订单:展示儿童婴儿价格') // 是否展示儿童婴儿价格权限
      if (!IsDisplayFlightChildAndInfantPrice && Number(this.XOrder.TravelType) === 0) {
        if (item.PassengerType === 2) {
          this.$toast(this.$t('ChildrenNonSupportBookable'))
          return false
        } else if (item.PassengerType === 3) {
          this.$toast(this.$t('BabyNonSupportBookable'))
          return false
        }
      } else {
        // 儿童婴儿提示
        if (item.isSmallFourteen) {
          this.$alert({
            content: this.$t('BabyTooSmallNonBookable'),
            confirmFn: () => {}
          })
          return false
        } else if (item.PassengerType === 2 && !this.childrenCanBook) {
          this._initCSmallFourteenAlertData(true, this.XOrder.IsCarryInfant, item.PassengerType)
          this.$refs.CSmallFourteenAlert && this.$refs.CSmallFourteenAlert.show()
          return false
        } else if (item.PassengerType === 3 && !this.babyCanBook) {
          this._initCSmallFourteenAlertData(this.XOrder.IsCarryChild, true, item.PassengerType)
          this.$refs.CSmallFourteenAlert && this.$refs.CSmallFourteenAlert.show()
          return false
        }
      }
      return true
    },

    /** 选择 */
    _select(item) {
      let index = this.currentSelectedPassengers.map(v => v.ID).indexOf(item.ID)
      // 非OA 校验成人儿童婴儿
      if (index < 0 && !this._checkChildrenAndBaby(item)) {
        return
      }

      if (index >= 0) {
        this.currentSelectedPassengers.splice(index, 1)
        return
      }
      if (item.Incomplete) {
        this.$toast(this.$t('BasicInformationIsIncompletePleaseEdit'))
        return
      }

      if (this.OrderBusinessType === 11 && this.currentSelectedPassengers.filter(v => v.GuestToRoomNo === this.GuestToRoomNo).length < this.powerDetails.maxLength) {
        this.currentSelectedPassengers.push(Object.assign(item, {GuestToRoomNo: this.GuestToRoomNo}))
      } else if (this.OrderBusinessType !== 11 && this.currentSelectedPassengers.length < this.powerDetails.maxLength) {
        this.currentSelectedPassengers.push(item)
      } else {
        this.$toast(this.$t('CanOnlySelectUpToXpassengers_x_x', 'function', [this.powerDetails.maxLength, this.powerDetails.title]))
      }
    },

    _confirm() {
      this.currentSelectedPassengers = this.currentSelectedPassengers.map(v => {
        v.Name = v.DefaultNameType === 0 ? v.ChName : (v.LastName && v.FirstName ? `${v.LastName}/${v.FirstName}` : `${v.LastName || ''}${v.FirstName || ''}`)
        v.Credentials && (v.Credential = v.Credentials.filter(a => a.CredentialType === v.DefaultCredentialType)[0])
        return v
      })

      let len = this.currentSelectedPassengers ? this.currentSelectedPassengers.length : 0
      for (let i = 0; i < len; i++) {
        if (!this._checkChildrenAndBaby(this.currentSelectedPassengers[i])) {
          return
        }
      }

      this.$emit('delegateWithConfirm', this.currentSelectedPassengers)
      this.close()
    },

    /** 校验弹框是否打开 如果弹框打开状态则 返回true */
    _checkAlertIsOpen(str, type) {
      let alt = this.$refs[str]
      if (alt && alt.show) {
        alt.close(type)
        return true
      }
    }
  },
  components: {
    CPassengerListItem,
    CDialogHeader,
    HsSearchBarNew,
    CHeader: () => import('components/c-header/c-header'),
    CPassengerHeaderMiddle: () => import('./c-passenger-header-middle'),
    HsDialog,
    HsClose,
    CSmallFourteenAlert,
    HsButton,
    HsCell1,
    HsNull,
    HsScroll,
    HsSection,
    PassengerDetails,
    Person
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-container-page
  width 100%
  height 100%
  >.hs-container-child-box
    border-radius 10px 10px 0 0
    overflow hidden
    background-color $color_background_gray_2
    height 80%
    top auto
.hs-container-child
  position absolute
  width 100%
  height 100%
  top 0
  left 0
  bottom 0
  background-color $color_white
  z-index 10
  >.table-view
    width 100%
    height calc(100% - 150px)
    overflow hidden
    background-color $color_gray_background_0

    .main-content {
      background $color_black_0
      border-radius 12px
      width calc(100% - 24px)
      margin-left 12px

      .custom-cell {
        @extend .flex-row
        @extend .flex-start
        width 100%
        height 40px

        > .button {
          @extend .hs-font-subtitle-middle
          margin 0 4px
          flex 1
          background rgba(240, 24, 42, 0.04)
          color $color_theme_300
          border none
          border-radius 6px
          // letter-spacing 0.5em

          &:first-child {
            margin-left 0
          }

          &:last-child {
            margin-right 0
          }

          &::before {
            content ' '
            display inline-flex
            width 16px
            height 16px
            margin-right 4px
          }

          &.btn-add {
            &::before {
              background url(@/assets/image/personal-center/passengers/icons_16pt_add.svg)
              background-size 100% 100%
            }
          }

          &.btn-import {
            &::before {
              background url(@/assets/image/personal-center/passengers/icons_16pt_import.svg)
              background-size 100% 100%
            }
          }
        }
      }
    }
  >footer
    @extends .flex-between
    width 100%
    padding 7px 10px
    background $color_white
    .hs-button
      margin 0 8px
      background $color_background_liner_theme_6
.from-bottom-slide-enter-active
.from-bottom-slide-leave-active
  transition: all 300ms
  -webkit-transition: all 300ms
.from-bottom-slide-enter
.from-bottom-slide-leave-to
  transform translateY(100%)
</style>
